import { jsx } from "react/jsx-runtime";
import { Radio } from "antd";
import classnames from "classnames";
import { forwardRef } from "react";
import { rootClass } from "./constant.js";
function InnerRadio(props, ref) {
    return /*#__PURE__*/ jsx(Radio, {
        ...props,
        ref: ref,
        className: classnames(props.className, rootClass)
    });
}
const radio_InnerRadio = /*#__PURE__*/ forwardRef(InnerRadio);
export { radio_InnerRadio as default };
